<template>
  <div class="hoder_module">
    <div class="enMainTitle">
      {{hoderTitle}}
    </div>
    <div>
      <el-row>
        <el-col :span="2">
          &nbsp;
        </el-col>
        <el-col :span="4" v-for="(hoder,index) in hoderArr1" :key="index">
          <a :href="hoder.url" target="_blank">
            <img :src="hoder.path" alt="" class="hoder_icon">
            <div class="title">{{hoder.name}}</div>
          </a>
        </el-col>
        <el-col :span="2">
          &nbsp;
        </el-col>
      </el-row>
    </div>
    <div class="hoder_space">
      <el-row>
        <el-col :span="2">
          &nbsp;
        </el-col>
        <el-col :span="4" v-for="(hoder,index) in hoderArr2" :key="index">
          <a :href="hoder.url" target="_blank">
            <img :src="hoder.path" alt="" class="hoder_icon">
            <div class="title">{{hoder.name}}</div>
          </a>
        </el-col>
        <el-col :span="2">
          &nbsp;
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { homeholder } from '@/api/enFrontApi/frontHome';
import axios from 'axios';
export default {
  data() {
    return {
      hoderTitle: 'Corporate Shareholder',
      hoderArr1: [
        {
          path: '../../../../static/img/hoder/logo-yto.png',
          name: 'YTO Group Corporation',
          url: 'http://www.yituo.com.cn/'
        },
        {
          path: '../../../../static/img/hoder/logo-njy.png',
          name: 'Chinese Academy of Agricultural Mechanization Sciences',
          url: 'http://www.caams.org.cn/'
        },

        {
          path: '../../../static/img/hoder/logo-lw.png',
          name: 'ZhongkeLongWang Innovation Technology Co., Ltd',
          url: 'http://www.chiaic.com/'
        },
        {
          path: '../../../../static/img/hoder/logo-jsyd.png',
          name: 'Jiangsu Yueda Intelligent Agricultural Enquipment Co., Ltd',
          url: 'http://www.jm-tractor.com/'
        },
        {
          path: '../../../static/img/hoder/logo-qh.png',
          name:
            'Luoyang Advanced Manufacturing Industrial R&D Center Tianjin Research Institute for Advanced Enquipment Tsinghua University',
          url: 'http://www.lamic.com.cn/'
        }
      ],
      hoderArr2: [
        {
          path: '../../../static/img/hoder/logo-nxkj.png',
          name: 'Nongxin Science & Technology(Beijing) Co., Ltd',
          url: 'http://www.chiaic.com/'
        },
        {
          path: '../../../../static/img/hoder/logo-zoom.png',
          name: 'Zoomlion Heavy Industry Science & Technology Co., Ltd',
          url: 'http://www.zoomlion-hm.com/'
        },
        {
          path: '../../../static/img/hoder/logo-krm.png',
          name: 'Kalman Naviqation',
          url: 'https://www.kalman-navigation.com/'
        },
        {
          path: '../../../static/img/hoder/logo-lts.png',
          name: 'Luoyang Tractor Research Institule Co., Ltd',
          url: 'http://www.lts.ac.cn/'
        },
        {
          path: '../../../static/img/hoder/logo-lyzk.png',
          name:
            'Luoyang Branch of Institule of Computing Technology of the Chinese   Academy of Sciences',
          url: 'http://www.chiaic.com/'
        }
      ],
      masterItems: [],
      masterShow: null,
      holderUrl: '/master/pagemaster.go'
    };
  },
  created() {
    // this.getHolderList();
  },
  methods: {
    getHolderList() {
      this.pingtaiArr = [];
      homeholder().then(res => {});
    },
    getHolderList1() {
      const AaA = axios.create({});
      this.pingtaiArr = [];
      AaA({
        url: this.holderUrl,
        methods: 'post'
      }).then(res => {});
    }
  }
};
</script>
<style scoped>
.hoder_module {
  width: 100%;
  height: 100%;
}
.title {
  color: #000;
  font-size: 16px;
  text-align: center;
}
.hoder_space {
  margin: 35px 0 20px 0;
}
.hoder_icon {
  border-radius: 82px;
}
.hoder_icon:hover {
  box-shadow: 0 0 10px #e79734;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/home/shareHoder.vue